<div class="parent-wrapper">
    <div class="child-wrapper flex-fill " *ngFor="let item of contentItems;let i = index">
        <img [src]="item.imgUrl" [alt]="'icon-' + i">
        <h5> {{ item.title }} </h5>
        <p> {{ item.description }} </p>
    </div>
</div>